
  import BaseIcon from '../../BaseIcon/src/BaseIcon.vue';
  import {
    ComponentInternalInstance,
    computed,
    defineComponent,
    getCurrentInstance,
    inject,
    reactive,
    Ref,
    ref,
  } from 'vue';
  export interface StepItemState {
    uid: number;
    currentStatus: string;
    setIndex: (val: number) => void;
    // calcProgress: (status: string) => void
  }

  export interface IStepsProps {
    space: number | string;
    active: number;
    direction: string;
    alignCenter: boolean;
    simple: boolean;
    finishStatus: string;
    processStatus: string;
  }

  export interface IStepsInject {
    props: IStepsProps;
    steps: Ref<StepItemState[]>;
  }

  export default defineComponent({
    name: 'BaseStepItem',
    components: { BaseIcon },
    props: {
      title: {
        type: String,
        required: true,
      },
      icon: {
        default: '',
        type: String,
      },
      description: {
        type: String,
        // required:
        default: '',
      },
      message: {
        type: String,
        // required:
        default: '',
      },
      datetime: {
        type: String,
        // required:
        default: '',
      },
      complete: {
        default: '',
        type: String,
      },
      status: {
        type: String,
        default: '',
        validator: (val: string): boolean =>
          ['', 'wait', 'process', 'finish', 'error', 'success'].includes(val),
      },
      times: {
        default: undefined,
        type: Number,
      },
    },
    setup(props) {
      const parent = inject<IStepsInject>('BaseStep') as IStepsInject;
      const currentInstance = getCurrentInstance() as ComponentInternalInstance;
      // const internalStatus = ref('')

      const currentStatus = computed(() => {
        return props.status;
      });
      const index = ref(-1);
      const selfActive = ref(false);

      const setIndex = (val) => {
        index.value = val;
      };

      const stepItemState = reactive({
        uid: computed(() => currentInstance.uid),
        currentStatus,
        setIndex,
      });
      parent.steps.value = [...parent.steps.value, stepItemState];
      const stepsCount = computed(() => {
        return parent.steps.value.length;
      });
      const isLast = computed(() => {
        return parent.steps.value[stepsCount.value - 1]?.uid === currentInstance.uid;
      });

      return {
        index,
        isLast,
        selfActive,
        currentStatus,
      };
    },
  });
